
//Note: Important!!!
//import the class here, not the object
import {HttpService} from 'service/HttpService';

import {StockAction} from 'AppAction';
import AppConstants from 'AppConstants';
import Dispatcher from 'service/Dispatcher';

const BASE_URL = AppConstants.BASE_API_URL+"/stock";


class StockAPI extends HttpService{

    getStocks(ownerAlias, onSuccess) {
        const url = "/"+ownerAlias+"/list";
        
        super.get(url, response => {
            Dispatcher.dispatch({
				type: StockAction.LOAD_OWNER_STOCKS,
                stocks: response.data,
                ownerAlias: ownerAlias
            });
            
            if(onSuccess && typeof onSuccess === 'function')
                onSuccess(response.data);
		});
    }


    refillStock(request, callback) {
        super.post("/refill", request, response => {
            Dispatcher.dispatchAnAlert(response.data);

            callback(true);
		});
    }


    transferStock(request, callback) {
        super.post("/transfer", request, response => {
            Dispatcher.dispatchAnAlert(response.data);
            callback(true);
		});
    }

    getStockHistories(stockProductId) {
        super.get("/history?stockProductId="+stockProductId, response => {
            Dispatcher.dispatch({
				type: StockAction.LOAD_STOCK_HISTORY,
                history: response.data,
                stockProductId: stockProductId
            });
		});
    }

}

export default new StockAPI(BASE_URL);





// WEBPACK FOOTER //
// ./src/service/api/StockAPI.js